import {
  addLikeToPost,
  LIKES_CUSTOM_FIELDNAME,
  retractLikeFromPost,
} from '../dao/likes';
import useCounter from '../helpers/useCounter';

/**
 * @param {import('../Kalkhoff').SparsePost} post Potentially liked post
 * @returns {[boolean, string, Function, boolean]} [isLiked, setLiked]
 */
export default function useLike(post) {
  return useCounter(
      post,
      LIKES_CUSTOM_FIELDNAME,
      addLikeToPost,
      retractLikeFromPost,
  );
}
